export const secondsToStringFormat = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  const sec_num = seconds - hours * 3600 - minutes * 60;

  let strHours = '';
  let strMinutes = '';
  let strSeconds = '';

  if (hours < 10) {
    strHours = `0${hours}`;
  }
  if (minutes < 10) {
    strMinutes = `0${minutes}`;
  }
  if (sec_num < 10) {
    strSeconds = `0${sec_num}`;
  }
  return `${strHours}:${strMinutes}:${strSeconds}`;
};
